/* unplugin-vue-components disabled */import script from "./control.vue?vue&type=script&setup=true&name=controll&lang=js"
export * from "./control.vue?vue&type=script&setup=true&name=controll&lang=js"

import "./control.vue?vue&type=style&index=0&id=204f8882&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-204f8882"]])

export default __exports__